import { render } from "./RelatorioDREIndex.vue?vue&type=template&id=6ba00dc0&scoped=true&ts=true"
import script from "./RelatorioDREIndex.vue?vue&type=script&lang=ts"
export * from "./RelatorioDREIndex.vue?vue&type=script&lang=ts"

import "./RelatorioDREIndex.vue?vue&type=style&index=0&id=6ba00dc0&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba00dc0"]])

export default __exports__